import { ssp } from 'sveltekit-search-params'

export function getOffsetQueryParamKey(namespace: string = '') {
	return namespace ? `${namespace}:offset` : 'offset'
}

export function createOffset(namespace: string = '') {
	return {
		[getOffsetQueryParamKey(namespace)]: ssp.number(0),
	}
}
